import publicInterfaces from './interface';

const interfaces = window.API.wrap(publicInterfaces, 'xhrInvoice');

export default interfaces;
